/* eslint-disable @typescript-eslint/no-unused-vars */
import i18n from 'i18next';
import detector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import en from './en.json';
import ar from './ar.json';

const resources = {
	en: {
		translation: en
	},
	ar: {
		translation: ar
	}
};
const isMobile = window.matchMedia(
	'only screen and (max-width: 760px)'
).matches;
const folder = isMobile ? 'tab' : 'web';
const backendOptions = {
	loadPath: `${process.env.REACT_APP_MASTER_LANGUAGE_JSON}/${folder}/{{lng}}.json`,
	allowMultiLoading: true,
	crossDomain: true
};

i18n.use(detector)
	.use(initReactI18next)
	.use(HttpApi)
	.init({
		// resources,
		fallbackLng: 'en', //language to use if translations in user language are not available
		interpolation: {
			escapeValue: false // not needed for react!!
		},
		// supportedLngs: ['en', 'ar','gu','hi'],
		backend: backendOptions
	});

export default i18n;
